/*!
 * ORDER/Order
 *
 * @author Andrew Hill
 */
const Utils = require('./Utils');
const Voucher = require('./Voucher');

const NULL_PRICE = {
    total: 0.00,
    unitPrice: 0.00,
    saving: 0.00
};

module.exports = {
    //Main state of the application
    Costs: {
        tapes: { total: 0.00, opts: {} },
        transfer_to: { total: 0.00, opts: {} },
        copies: { total: 0.00, opts: {} },
        discount: { total: 0.00 }
    },

    growlingDiscountMessage: "",

    canDiscountGrowl: function(message, type){
        return message+type !== this.growlingDiscountMessage;
    },

    discountGrowl: function(message, type){
        if(this.canDiscountGrowl(message, type)){
            this.growlingDiscountMessage = message+type;
            var that = this;

            $.growl({
                title: "Discount",
                style: type,
                message: message,
                duration: 5000,
                remove: function(){ that.growlingDiscountMessage = ""; }
            });
        }
    },

    checkVoucher: function(voucherCode){
        voucherCode = Utils.removeSpace(voucherCode).toUpperCase();

        var voucher = new Voucher(voucherCode, this);
        voucher.doDiscountAmount();

        return voucher;
    },

    /**
     * Sum up the total number of tapes
     */
    getNumberOfTapes: function(){
        var total = 0;

        for (var idx in ORDER.Options.tapes) {
            if (!ORDER.Options.tapes.hasOwnProperty(idx)) continue;

            total += parseInt($('#qty_' + idx).val());
        }

        return total;
    },

    getDiscountableCost: function(){
        return this.Costs.tapes.total
            + this.Costs.transfer_to.total
            + this.Costs.copies.total;
    },

    isCopiesOrdered: function(){
        var ordered = false;

        //Check each type of copy to see if it's checked
        for (var idx in ORDER.Options.copy) {
            if (!ORDER.Options.copy.hasOwnProperty(idx)) continue;

            var $__copy = $("#copy_" + idx);

            if ($__copy.is(":checked") && parseInt($("#qty_" + idx).val()) > 0) {
                ordered = true;
            }
        }

        return ordered;
    },

    getTierPriceFromQty: function(qty, tierPrices) {
        if(qty == null || tierPrices == null) {
            return null;
        }

        var compareFunction = function(tierA, tierB) {
            if(tierA.tier < tierB.tier) {
                return -1;
            }
            if(tierA.tier > tierB.tier) {
                return 1;
            }
            return 0;
        };
        tierPrices = tierPrices.sort(compareFunction);

        var getReducer = function(tqty){
            var qty = tqty;
            return function (accumulator, currentValue) {
                if(qty >= currentValue.tier) {
                    if (accumulator.tier > currentValue.tier) {
                        return accumulator;
                    } else {
                        return currentValue;
                    }
                } else {
                    return accumulator;
                };
            }
        };

        var tier = tierPrices.reduce(getReducer(qty), {"tier": 0, "cost": 0});

        return tier.cost;
    },

    /**
     * Calculate the costs for the initial sources
     */
    calcTapeCosts: function(){
        //Repeat for each source according to the ORDER.Options.tapes object
        for (var idx in ORDER.Options.tapes) {
            if (!ORDER.Options.tapes.hasOwnProperty(idx)) continue;

            //Quantity element
            var $__qty = $('#qty_' + idx);
            //Quantity of this tape type
            var qty = $__qty.val();

            this.Costs.tapes.opts[idx] = this.getSourceCost(ORDER.Options.tapes[idx], qty);
        }

        var subtotalTapes = this.getSourceSubTotal(this.Costs.tapes.opts);

        if(subtotalTapes < ORDER.Options.min_tape_cost) {
            subtotalTapes = ORDER.Options.min_tape_cost;
        }

        this.Costs.tapes.total = subtotalTapes;

        return true;
    },

    getSourceCost: function(source, qty) {
        var cost = {};

        if (source.tierPrices !== null) {
            var tierPrice = this.getTierPriceFromQty(qty, source.tierPrices);
            cost.total = qty * tierPrice;
            cost.unitPrice = tierPrice;
            cost.saving = qty * (source.cost - tierPrice);
        } else {
            cost.total = qty * source.cost;
            cost.unitPrice = source.cost;
            cost.saving = 0.0;
        }

        return cost;
    },

    getSourceSubTotal: function(costsTapesOpts){
        var subTotal = 0.0;

        for (var idx in costsTapesOpts) {
            if (!costsTapesOpts.hasOwnProperty(idx)) continue;
            subTotal = subTotal + costsTapesOpts[idx].total;
        }

        return subTotal;
    },

    getBulkSaving: function(costsTapesOpts){
        var saving = 0.0;

        for (var idx in costsTapesOpts) {
            if (!costsTapesOpts.hasOwnProperty(idx)) continue;
            saving += costsTapesOpts[idx].saving;
        }

        return saving;
    },

    /**
     * Calculate the costs for the digital file creation
     */
    calcTransferToCosts: function(){
        var numTapes = this.getNumberOfTapes();

        this.Costs.transfer_to.sub_tt_usb_copies = 0.00;

        for(var idx in ORDER.Options.transfer_to){
            if (!ORDER.Options.transfer_to.hasOwnProperty(idx)) continue;

            var $__transferTo = $("#destination_" + idx);
            var $__dvds = $('#destination_' + idx + '_dvds');
            var $__usb_copies = $('#destination_' + idx + '_extra_usb');
            var $__usb_copies_qty = $('#destination_' + idx + '_extra_usb_qty');

            this.Costs.transfer_to.opts[idx] = {};

            this.Costs.transfer_to.opts[idx] = this.getTransferToCost(ORDER.Options.transfer_to[idx], numTapes);

            if ($__transferTo.is(":checked")) {
                $__transferToIdx = idx;
            } else {
                //Make sure the extra dvds is not checked
                $__dvds.prop("checked", false);
                //Make sure the extra usb copies is not checked
                $__usb_copies.prop("checked", false);
            }

            //Check for DVD copies for Digital files
            if($__dvds.is(":checked")){
                this.Costs.transfer_to.opts[idx].dvds = this.calcTransferToDvdCost(numTapes, ORDER.Options.copies_tt_cost);
            } else {
                this.Costs.transfer_to.opts[idx].dvds = 0.00;
            }

            this.Costs.transfer_to.opts[idx].usb_copies_unit = this.calcTransferToExtraUsbCost(this.Costs.transfer_to.opts[idx], ORDER.Options.extra_usb_mulitplier_cost);
            //Check for DVD copies for Digital files
            if($__usb_copies.is(":checked")){
                this.Costs.transfer_to.opts[idx].usb_copies = $__usb_copies_qty.val() * this.Costs.transfer_to.opts[idx].usb_copies_unit;
                this.Costs.transfer_to.sub_tt_usb_copies = this.Costs.transfer_to.opts[idx].usb_copies;
            } else {
                this.Costs.transfer_to.opts[idx].usb_copies = 0.00;
            }
        }

        this.Costs.transfer_to.sub_tt_dvds = this.getTransferToDvdSubTotal(this.Costs.transfer_to.opts, $__transferToIdx);
        this.Costs.transfer_to.total = this.getTransferToSubtotal(this.Costs.transfer_to.opts, $__transferToIdx) + this.Costs.transfer_to.sub_tt_dvds + this.Costs.transfer_to.sub_tt_usb_copies;

        return true;
    },

    getTransferToCost: function(transferTo, numTapes) {
        var cost = {};

        if (transferTo.tierPrices !== null) {
            var tierPrice = this.getTierPriceFromQty(numTapes, transferTo.tierPrices);
            cost.total = numTapes * tierPrice;
            cost.unitPrice = tierPrice;
            cost.saving = numTapes * (transferTo.cost - tierPrice);
        } else {
            cost.total = numTapes * transferTo.cost;
            cost.unitPrice = transferTo.cost;
            cost.saving = 0.0;
        }

        return cost;
    },

    calcTransferToDvdCost: function(numTapes, copiesCost) {
        return numTapes * copiesCost;
    },

    calcTransferToExtraUsbCost: function(transferToCost, multiplier) {
        if (typeof multiplier !== "undefined") {
            return transferToCost.total * multiplier;
        }

        return 0;
    },

    getTransferToSubtotal: function(costsTransferToOpts, idx) {
        var subTotal = 0.0;

        if(!costsTransferToOpts.hasOwnProperty(idx)) {
            return subTotal;
        }

        subTotal = subTotal + costsTransferToOpts[idx].total;

        return subTotal;
    },

    getTransferToDvdSubTotal: function(costsTransferToOpts, idx) {
        var subTotal = 0.0;

        if(!costsTransferToOpts.hasOwnProperty(idx)) {
            return subTotal;
        }

        subTotal = subTotal + costsTransferToOpts[idx].dvds;

        return subTotal;
    },

    calcCopiesCosts: function(){
        var qty_copies = 0;
        var sub_copies = 0.00;

        //Update the sub totals for each type of tape
        for (var idx in ORDER.Options.copy) {
            if (!ORDER.Options.copy.hasOwnProperty(idx)) continue;

            var $__copy = $("#copy_" + idx);
            var $__qty = $('#qty_' + idx);

            if ($__copy.is(":checked")) {
                var sub = $__qty.val() * ORDER.Options.copy[idx].cost;

                if(idx == 'copy_set'){
                    sub = sub * this.getNumberOfTapes();
                }

                sub_copies = sub_copies + sub;

                this.Costs.copies.opts[idx] = sub;

                qty_copies = $__qty.val();
            } else {
                this.Costs.copies.opts[idx] = 0;
            }
        }

        this.Costs.copies.total = sub_copies;

        return true;
    },

    calcDiscountCosts: function(){
        var sub_discount = 0.00;

        var $__voucher = $('#voucher');

        if($__voucher.val() != "") {
            var voucher = this.checkVoucher($__voucher.val());

            if(voucher.errors.length > 0){
                for(var idx in voucher.errors){
                    if (!voucher.errors.hasOwnProperty(idx)) continue;

                    this.discountGrowl(voucher.errors[idx].message, 'warning');

                    $__voucher.css("color", "red");
                }
            } else {
                sub_discount = voucher.discountAmount;
                $__voucher.css("color", '#006633');

                this.discountGrowl("£" + voucher.discountAmount.toFixed(2) + " discount has been applied", 'notice');
            }
        }

        this.Costs.discount.total = +sub_discount.toFixed(2);

        return true;
    },

    /* on change handler for tapes */
    updateTapeCost: function(){
        //this.growlingDiscount = false;

        if(!this.calcTapeCosts()){
            //Couldn't calc the tape costs
            return;
        }

        numtapes = this.getNumberOfTapes();
        $('#num_tapes').html('<b>' + numtapes + '</b>');
        $('#qty_tapes').val(numtapes);

        //update ui
        for(var idx in this.Costs.tapes.opts){
            if (!this.Costs.tapes.opts.hasOwnProperty(idx)) continue;

            if(typeof this.Costs.tapes.opts[idx] != 'undefined'){
                $('#sub_' + idx).html('<b>&pound; ' + this.Costs.tapes.opts[idx].total.toFixed(2) + '</b>');
                $('#unit-price-' + idx).html('&pound; ' + this.Costs.tapes.opts[idx].unitPrice.toFixed(2))
            }
        }

        var saving = this.getBulkSaving(this.Costs.tapes.opts);
        $('#tier-price-saving').html("£" + saving.toFixed(2));
        if (saving > 0) {
            $('.tier-price-saving').addClass('saving');
        } else {
            $('.tier-price-saving').removeClass('saving');
        }

        $('#sub_tapes').html('<b>&pound; ' + this.Costs.tapes.total.toFixed(2) + '</b>');
        $('#sub_total_tapes').val(this.Costs.tapes.total.toFixed(2));

        this.updateTransferToCost();
        this.updateCopiesCost();
        this.updateDiscountCost();
        this.updateTotal();
    },

    updateTransferToCost: function(){
        if(this.checkTransferToAndCopies()){
            this.warnTransferToAndCopies();
        }

        if(!this.calcTransferToCosts()){
            //Couldn't calc the transfer to costs
            return;
        }

        for(var idx in this.Costs.transfer_to.opts){
            if (!this.Costs.transfer_to.opts.hasOwnProperty(idx)) continue;

            if(typeof this.Costs.transfer_to.opts[idx] != 'undefined'){
                $("#sub_destination_" + idx).html('<b>&pound; ' + this.Costs.transfer_to.opts[idx].total.toFixed(2) + '</b>');

                if(typeof this.Costs.transfer_to.opts[idx].dvds != 'undefined') {
                    $("#sub_destination_" + idx + "_dvds").html('<b>&pound; ' + this.Costs.transfer_to.opts[idx].dvds.toFixed(2) + '</b>');
                }

                //destination_mp4__dvd_per_tape
                $("#destination_" + idx + "_per_tape").text(this.Costs.transfer_to.opts[idx].unitPrice.toFixed(2));

                if(typeof this.Costs.transfer_to.opts[idx].usb_copies != "undefined") {
                    $("#sub_destination_" + idx + "_extra_usb").html('<b>&pound; ' + this.Costs.transfer_to.opts[idx].usb_copies.toFixed(2) + '</b>');

                    var unitPrice = this.Costs.transfer_to.opts[idx].usb_copies_unit.toFixed(2);

                    $__unitPriceUsbCopies = $("#destination_" + idx + "_extra_usb_title");
                    var calculatedCostText = $__unitPriceUsbCopies.html();
                    //Is it first time - replace placeholder text
                    if (typeof calculatedCostText !== "undefined" && calculatedCostText.search("{CALCULATED_COST}") !== -1) {
                        calculatedCostText = calculatedCostText.replace("{CALCULATED_COST}", "<span id='destination_" + idx + "_extra_usb_title_span'>" + unitPrice + "</span>");
                        $__unitPriceUsbCopies.html(calculatedCostText);
                    //Subsequently update the unitPrice only
                    } else {
                        $("#destination_" + idx + "_extra_usb_title_span").text(unitPrice);
                    }
                }
            }
        }

        $("#sub_total_destination").val(this.Costs.transfer_to.total);

        this.updateDiscountCost();
        this.updateTotal();
    },

    /**
     * Check if the Transfer To state, DVD set and DVD extra copies are in accordance
     */
    checkTransferToAndCopies: function(){
        if (this.isCopiesOrdered()) {
            for (var idx in ORDER.Options.transfer_to) {
                $__dvds = $('#destination_' + idx + '_dvds');

                if(
                    $("#destination_" + idx).is(":checked") &&
                    $__dvds.length != 0 &&
                    !$__dvds.is(":checked")) {
                    return true;
                }
            }
        }

        return false;
    },

    warnTransferToAndCopies: function(){
        for (var idx in ORDER.Options.transfer_to) {
            if ($("#destination_" + idx).is(":checked")) {
                $('#destination_' + idx + '_dvds').prop("checked", true);
            }
        }

        $.growl.warning({ duration: 10000, message: "You've ordered your conversion onto Digital Files MP4 or download so in order to have copies of DVDs as well you must tick the box labelled <br />'Please also produce a DVD from each of my tapes £4.00 per tape.'" });
        $.growl.notice({ duration: 12000, message: "We've ticked the box for you. You can untick it if you decide not to have any DVD copies (Click 'Clear All Copies')."});
    },

    noCopies: function(){
        for (var idx in ORDER.Options.copy) {
            if (!ORDER.Options.copy.hasOwnProperty(idx)) continue;

            $("#copy_" + idx).prop("checked", false);
        }

        this.updateCopiesCost();
    },

    updateCopiesCost: function(){
        for (var idx in ORDER.Options.copy) {
            if (!ORDER.Options.copy.hasOwnProperty(idx)) continue;

            var $__copy = $("#copy_" + idx);
            var $__qty = $("#qty_" + idx);

            if ($__copy.is(":checked") && parseInt($__qty.val()) == 0) {
                $__qty.val("1");
            } else if(!$__copy.is(":checked")) {
                $__qty.val("0");
            }
        }

        if(!this.calcCopiesCosts()){
            //Couldn't calc copies
            return;
        }

        for(var idxx in this.Costs.copies.opts){
            if (!this.Costs.copies.opts.hasOwnProperty(idxx)) continue;
            if(typeof this.Costs.copies.opts[idxx] != 'undefined'){
                $("#sub_copy_" + idxx).html('<b>&pound; ' + this.Costs.copies.opts[idxx].toFixed(2) + '</b>');
            }
        }

        $('#sub_total_copies').val(this.Costs.copies.total.toFixed(2));
        $('#qty_copies').val(this.Costs.copies.total.toFixed(2));

        if(this.checkTransferToAndCopies()){
            this.warnTransferToAndCopies();
            this.updateTransferToCost();
        }

        this.updateDiscountCost();
        this.updateTotal();
    },

    updateDiscountCost:function(){
        if(!this.calcDiscountCosts()){
            //Couldn't calc copies
            return;
        }

        $('#sub_total_discount').val(this.Costs.discount.total.toFixed(2));
        $('#sub_discount_cost').html('<b>&pound; ' + this.Costs.discount.total.toFixed(2) + '</b>');

        this.updateTotal();
    },

    updateTotal: function(){
        var total = this.Costs.tapes.total
            + this.Costs.transfer_to.total
            + this.Costs.copies.total
            - this.Costs.discount.total;

        $('#order_1_total').val(total);
        $('#sub_total_cost').html('<b>&pound; ' + total.toFixed(2) + '</b>');
    }
};